export default function init() {
    const links = document.querySelectorAll('.lylan-history__nav-link');
    const observer = new IntersectionObserver(entries => {
        entries[0].isIntersecting && links.forEach(link => link.setAttribute('aria-current', link === entries[0].target._link ? 'true' : 'false'));
    }, {rootMargin: '-80px 0px -90% 0px'});
    links.forEach(link => {
        const section = document.getElementById(link.getAttribute('href').replace(/^[^#]*#/, ''));
        if (section) {
            section._link = link;
            observer.observe(section);
        }
    });
}